export default __webpack_public_path__ + "static/media/telescope.464509c8.png";